import axios from 'axios'

export default {
  data () {
    return {
      lumbreSignerPort: process.env?.VUE_APP_LUMBRESIGNER_PORT || '8081',
      enableLumbredocsSigner: process.env?.VUE_APP_ENABLE_LUMILE_APP_SIGNER === 'yes',
      enableSocketIO: process.env?.VUE_APP_SOCKET_ENABLED === 'yes'
    }
  },
  methods: {
    async checkLumbreDocsSigner () {
      try {
        const api = axios.create()
        const localSignerPromise = api(`http://localhost:${this.lumbreSignerPort}/version`)
        const signerLastVersionPromise = api('/versions/lumbre-signer')
        const [localSigner, signerLastVersion] = await Promise.all([localSignerPromise, signerLastVersionPromise])
        let error
        if (parseFloat(localSigner.data.version) < parseFloat(signerLastVersion.data)) {
          error = {
            type: 'update_required',
            message: 'LumbreDocs Signer necesita actualizarse.'
          }
        }
        if (error) throw error
      } catch (error) {
        if (error?.type === 'update_required') {
          this.lmToastDangerMessage(
            error.message,
            'Error'
          )
        } else {
          if (process.env?.VUE_APP_ENABLE_REAMAZE === 'yes') {
            window.Reamaze.popup('/kb/info-tecnica/como-descargar-el-firmador')
            this.lmToastDangerMessage(
              'Para poder hacer una firma digital necesita tener instalado LumbreDocs Signer, siga los pasos que se muestran en la ayuda.',
              'Error'
            )
          }
        }
        throw error
      }
    },
    // Metodo para ser usado en table.vue de tabla de datos cuyo origen de datos
    // sean documentos, al invocarlo subscribe a los eventos que puedan ocurrir via
    // socketio relacionados a los documentos.
    subscribeToDocumentsEvents () {
      if (this.enableSocketIO && this.serviceSource === 'documents') {
        for (const document of this.table.items) {
          this.sockets.subscribe(`onDocument_${document.id}`, this.showNotificationOnDocumentEvent)
        }
      }
    },
    // Metodo para ser usado en table.vue de tabla de datos cuyo origen de datos
    // sean documentos, al invocarlo desubscribe a los eventos que puedan ocurrir via
    // socketio relacionados a los documentos.
    unSubscribeToDocumentsEvents () {
      this.showReloadButton = false
      if (this.enableSocketIO && this.serviceSource === 'documents') {
        for (const document of this.table.items) {
          this.sockets.unsubscribe(`onDocument_${document.id}`)
        }
      }
    },
    showNotificationOnDocumentEvent (event) {
      if (event.hasOwnProperty('id') && event.id) {
        const foundDocument = this.table.items.find(i => i.id === event.id)
        if (foundDocument && foundDocument.hasOwnProperty('document-primary')) {
          foundDocument['document-primary'].hasBeenChanged = true
          this.key++
          this.showReloadButton = true
        }
      }
    }
  }
}
